import { Alert, Badge, Card, Descriptions, Spin } from 'antd';
import { useHealth } from '../hooks/use-health';

/**
 * Phase 0 smoke-test surface: verifies the admin client can reach the server
 * and render its response envelope end-to-end. Replaced by the real dashboard
 * in later phases.
 */
export function HealthPanel() {
  const { data, isLoading, isError, error } = useHealth();

  if (isLoading) {
    return (
      <Card>
        <Spin /> Checking API status…
      </Card>
    );
  }

  if (isError || !data) {
    return (
      <Alert
        type="error"
        showIcon
        message="Cannot reach the API"
        description={error instanceof Error ? error.message : 'Unknown error'}
      />
    );
  }

  return (
    <Card title="System status">
      <Descriptions column={1} size="small">
        <Descriptions.Item label="API">
          <Badge status={data.status === 'ok' ? 'success' : 'warning'} text={data.status} />
        </Descriptions.Item>
        <Descriptions.Item label="Database">
          <Badge
            status={data.checks.database === 'up' ? 'success' : 'error'}
            text={data.checks.database}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Uptime">{data.uptimeSeconds}s</Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
